export const firstGuarantorTitle = 'Cadastre a primeira pessoa avalista';

export const secondGuarantorTitle = 'Cadastre a segunda pessoa avalista';
